<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>
              阶段控制参数
              <el-tooltip class="item" effect="dark"
                content="以空气温度为例，当前棚内植物最佳生长环境空气温度为20℃~25℃，阶段控制参数为-10~0,0~10，则将空气划分为两个空气温度控制区间，10℃~20℃，25℃~35℃，当前空气温度落入对应的阶段控制区间时会触发不同的控制设备对空气温度进行调控。"
                placement="top">
                <i class="el-icon-question" style="color: #409eff; margin-left: 5px"></i>
              </el-tooltip>
            </h3>
          </div>
          <div class="div-button">
            <el-button type="primary" class="adduser" @click="handleAdd">添加阶段控制参数</el-button>

          </div>
        </div>
        <div class="div-step">
          <el-steps :active="4" align-center>
            <el-step title="添加环境模型"></el-step>
            <el-step title="添加环境参数"></el-step>
            <el-step title="环境传感器"></el-step>
            <el-step title="执行控制器"></el-step>
            <el-step title="阶段控制参数"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="环境参数：" prop="paramId">
            <el-select v-model="searchForm.paramId" placeholder="请选择环境参数" clearable @change="handleSearch">
              <el-option v-for="item in paramArray" :key="item.id" :label="item.paramName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="环境参数">
              <template slot-scope="scope">
                <p>{{ scope.row.paramType | paramTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="开始阶段">
              <template slot-scope="scope">
                <p>{{ scope.row.startStage }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="结束阶段">
              <template slot-scope="scope">
                <p>{{ scope.row.endStage }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleDevice(scope.row)" type="text" size="small">阶段设备</el-button>
                <el-button @click="handlePriority(scope.row)" type="text" size="small">阶段优先级</el-button>
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex;justify-content: space-around;">
          <div></div>
          <div class="pagination-container" style="margin-left: 12rem;margin-top: 3rem;">
            <div class="page"></div>
            <div class="pagination-content-container">
              <el-pagination background layout="prev, pager, next, jumper" class="pageTap"
                @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize"
                :total="total"></el-pagination>
            </div>
          </div>
          <div style="margin-top: 3.7rem;">
            <el-button type="primary" class="adduser" @click="handlePrev">上一步</el-button>
            <el-button type="primary" class="adduser" @click="handleNext">下一步</el-button>
            <el-button type="primary" class="adduser" @click="handleReturn">返回环境模型</el-button>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center
          style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="环境参数：" prop="paramId">
                  <el-select v-model="ruleForm.paramId" placeholder="请选择环境参数" clearable>
                    <el-option v-for="item in paramArray" :key="item.id" :label="item.paramName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开始阶段：" prop="startStage">
                  <el-input-number v-model="ruleForm.startStage" placeholder="请输入开始阶段" :min="-99999999" :max="99999999"
                    :precision="2" size="small"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="结束阶段：" prop="endStage">
                  <el-input-number v-model="ruleForm.endStage" placeholder="请输入开始阶段" :min="-99999999" :max="99999999"
                    :precision="2" size="small"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 阶段设备 -->
        <el-dialog title="阶段设备" :visible.sync="addEditIsDialogDevice" :before-close="handleCancelDevice" width="800px"
          center style="z-index: 10000">
          <el-form ref="ruleFormDevice" label-width="120px" class="demo-ruleForm">
            <div v-for="(item, index) in ruleFormDevice" :key="index">
              <el-row>
                <el-col :span="11">
                  <el-form-item label="执行控制器：" prop="modelDeviceSwitchId">
                    <el-select v-model="item.modelDeviceSwitchId" placeholder="请选择执行控制器" clearable>
                      <el-option v-for="item2 in deviceSwitchArray" :key="item2.id"
                        :label="item2.switchName + '_' + item2.switchAttrName" :value="item2.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="自然控制判断：" prop="type">
                    <el-select v-model="item.type" placeholder="请选择自然控制判断" clearable>
                      <el-option label="无判断" value="0"></el-option>
                      <el-option label="自然控制" value="1"></el-option>
                      <el-option label="设备控制" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <a @click="handleDelDevice(index)" style="
                      height: 40px;
                      line-height: 40px;
                      margin-left: 30px;
                      color: red;
                    ">删除</a>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="执行优化级：" prop="priority">
                    <el-input-number v-model="item.priority" placeholder="请输入执行优化级" :min="0" :max="99999999"
                      :precision="0" :step="1" size="small"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item style="position: relative">
                  <el-button type="text" @click="handleAddDevice"
                    style="position: absolute; margin-left: -20px">+添加阶段设备</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancelDevice">取 消</el-button>
            <el-button type="primary" @click="handleSaveDevice">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 阶段优先级 -->
        <el-dialog title="阶段优先级" :visible.sync="addEditIsDialogPriority" :before-close="handleCancelPriority"
          width="800px" center style="z-index: 10000">
          <el-form ref="ruleFormPriority" label-width="120px" class="demo-ruleForm">
            <div v-for="(item, index) in ruleFormPriority" :key="index">
              <el-row>
                <el-col :span="11">
                  <el-form-item label="单次检测时间：" prop="checkTime">
                    <el-input-number v-model="item.checkTime" placeholder="请输入单次检测时间（s）" :min="0" :max="99999999"
                      :precision="0" :step="1" size="small"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="总共检测时间：" prop="totalCheckTime">
                    <el-input-number v-model="item.totalCheckTime" placeholder="请输入总共检测时间（s）" :min="0" :max="99999999"
                      :precision="0" :step="1" size="small"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <a @click="handleDelPriority(index)" style="
                      height: 40px;
                      line-height: 40px;
                      margin-left: 30px;
                      color: red;
                    ">删除</a>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="执行优化级：" prop="priority">
                    <el-input-number v-model="item.priority" placeholder="请输入执行优化级" :min="0" :max="99999999"
                      :precision="0" :step="1" size="small"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item style="position: relative">
                  <el-button type="text" @click="handleAddPriority"
                    style="position: absolute; margin-left: -20px">+添加阶段优先级</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancelPriority">取 消</el-button>
            <el-button type="primary" @click="handleSavePriority">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        evnId: "",
        paramId: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        paramId: "",
        startStage: "",
        endStage: "",
      },
      rules: {
        // 添加编辑表单规则
        paramId: [
          {
            required: true,
            message: "请选择环境参数",
            trigger: "change",
          },
        ],
        startStage: [
          {
            required: true,
            message: "请输入开始阶段",
            trigger: "blur",
          },
        ],
        endStage: [
          {
            required: true,
            message: "请输入结束阶段",
            trigger: "blur",
          },
        ],
      },
      addEditTitle: "添加阶段控制参数", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      addEditId: "", // 添加编辑id
      ruleFormDevice: [], // 阶段设备表单
      addEditIsDialogDevice: false, // 阶段设备弹窗是否显示
      ruleFormPriority: [], // 阶段优先级表单
      addEditIsDialogPriority: false, // 阶段优先级弹窗是否显示
      paramArray: [], // 环境参数数组
      deviceSwitchArray: [], // 执行控制器数组
    };
  },
  created() {
    this.searchForm.paramId = this.$route.query.paramId;
    this.ruleForm.paramId = this.$route.query.paramId;
    this.searchForm.evnId = this.$route.query.evnId;

    // 获取环境参数列表
    this.getGrowthModelEvnParamAll();

    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        evnId: this.$route.query.evnId,
        paramId: "",
      };

      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthModelStageControlList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.growthModel
            .delGrowthModelStageControl(row.id)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.getList();
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑阶段控制参数";
      this.ruleForm.id = row.id;
      this.ruleForm.modelId = this.paramId;

      // 获取详情
      this.$api.growthModel
        .getGrowthModelStageControl({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm = res.data;
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加阶段控制参数";
      this.ruleForm.id = "";
      this.ruleForm.modelId = this.paramId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthModelStageControl(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 阶段设备
    handleDevice(row) {
      this.addEditIsDialogDevice = true;
      this.addEditId = row.id;
      this.$api.growthModel.getModelStageDevices({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((val) => {
            val.type = val.type != undefined ? val.type.toString() : "";
          });
          this.ruleFormDevice = res.data;
        }
      });

      // 获取执行控制器列表
      this.getGrowthModelDeviceSwitchList(row.paramId);
    },
    // 添加阶段设备
    handleAddDevice() {
      this.ruleFormDevice.push({
        id: "",
        stageControlId: this.addEditId,
        modelDeviceSwitchId: "",
        type: "",
        priority: "",
      });
    },
    // 删除阶段设备
    handleDelDevice(index) {
      this.ruleFormDevice.splice(index, 1);
    },
    // 关闭阶段设备
    handleCancelDevice() {
      this.ruleFormDevice = [];
      this.addEditIsDialogDevice = false;
    },
    // 保存阶段设备
    handleSaveDevice() {
      let flag = false;
      this.ruleFormDevice.forEach((val) => {
        if (!val.modelDeviceSwitchId || val.modelDeviceSwitchId === "") {
          flag = true;
          return;
        }
        if (!val.type || val.type === "") {
          flag = true;
          return;
        }
        if (val.priority === "") {
          flag = true;
          return;
        }
      });

      if (flag) {
        this.$message({
          type: "error",
          message: "请完善阶段设备信息",
        });
        return;
      }

      // 保存
      this.$api.growthModel
        .saveGrowthModelStageDeviceList({
          stageControlId: this.addEditId,
          saveModelStageDevices: this.ruleFormDevice,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.handleCancelDevice();
          }
        });
    },
    // 阶段优先级
    handlePriority(row) {
      this.addEditIsDialogPriority = true;
      this.addEditId = row.id;
      this.$api.growthModel
        .getGrowthModelStageControlPrioritys({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.ruleFormPriority = res.data;
          }
        });
    },
    // 添加阶段优先级
    handleAddPriority() {
      this.ruleFormPriority.push({
        id: "",
        stageControlId: this.addEditId,
        checkTime: "",
        totalCheckTime: "",
        priority: "",
      });
    },
    // 删除阶段优先级
    handleDelPriority(index) {
      this.ruleFormPriority.splice(index, 1);
    },
    // 关闭阶段优先级
    handleCancelPriority() {
      this.ruleFormPriority = [];
      this.addEditIsDialogPriority = false;
    },
    // 保存阶段优先级
    handleSavePriority() {
      let flag = false;
      this.ruleFormPriority.forEach((val) => {
        if (val.checkTime === "") {
          flag = true;
          return;
        }
        if (val.totalCheckTime === "") {
          flag = true;
          return;
        }
        if (val.opening === "") {
          flag = true;
          return;
        }
      });

      if (flag) {
        this.$message({
          type: "error",
          message: "请完善阶段优先级信息",
        });
        return;
      }

      // 保存
      this.$api.growthModel
        .saveGrowthModelStageControlPriorityList({
          stageControlId: this.addEditId,
          saveGrowthModelStageControlPrioritys: this.ruleFormPriority,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.handleCancelPriority();
          }
        });
    },
    // 获取大棚设备标签列表
    getControlDevices() {
      this.$api.growthModel
        .getControlDevices({
          type: 3,
          deviceSign: this.$route.query.paramType,
          groupId: this.$route.query.groupId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceAttributeArray = res.data;
          }
        });
    },
    // 获取环境参数列表
    getGrowthModelEvnParamAll() {
      this.$api.growthModel
        .getGrowthModelEvnParamAll({ evnId: this.$route.query.evnId })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              val.paramName = this.$filters.paramTypeName(val.paramType);
            });
            this.paramArray = res.data;
          }
        });
    },
    // 获取执行控制器列表
    getGrowthModelDeviceSwitchList(paramId) {
      this.$api.growthModel
        .getGrowthModelDeviceSwitchAll({
          paramId: paramId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceSwitchArray = res.data;
          }
        });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: "second",
        },
      });
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `addDeviceSwitch`,
        query: {
          evnId: this.$route.query.evnId,
          groupId: this.$route.query.groupId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 0px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>